import React from 'react';

export class SearchResultFooter extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        this.props.onClick(e);
    }

    render() {
        if (this.props.searchResult &&
                this.props.searchResultRange.last + 1 < this.props.searchResultRange.length) {
            return (
                <div className="subtitleFooter">
                    <div className="col-md-12">
                        <div className="panel panel-default">
                            <div className="panel-body text-center">
                                <strong>
                                    <a onClick={this.handleClick} href="javascript:void(0)">
                                        Mostrar m&aacute;s resultados
                                    </a>
                                </strong>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="subtitleFooter" />
            );
        }
    }
}


// WEBPACK FOOTER //
// ../components/SearchResultFooter/SearchResultFooter.jsx